import React from 'react';
import './ErrorMessageTitle.less';

export const ErrorMessageTitle = ({text}) => {
	return <h2 className="error-message-title">{text}</h2>
}
